import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'

import { IncomingCallButtonVariants } from './IncomingCallButton.style'

const callIconParts = ['container', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(callIconParts)
export const CallIconStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      boxSize: '3.75rem',
      borderRadius: 'full',
      border: '2px solid',
    },
    icon: {
      boxSize: '1.5rem',
    },
  },
  variants: {
    [IncomingCallButtonVariants.Reject]: {
      container: {
        backgroundColor: 'red.solid',
        borderColor: 'transparent',
      },
      icon: {
        color: 'red.contrast',
      },
    },
    [IncomingCallButtonVariants.Accept]: {
      container: {
        backgroundColor: 'green.solid',
        borderColor: 'transparent',
      },
      icon: {
        color: 'green.contrast',
      },
    },
    [IncomingCallButtonVariants.AcceptWithOverlap]: {
      container: {
        backgroundColor: 'green.solid',
        borderColor: 'transparent',
        marginLeft: '-0.75rem',
        boxShadow: asChakraVariable({ default: 'shadows.subtle' }),
      },
      icon: {
        color: 'green.contrast',
      },
    },
    [IncomingCallButtonVariants.EndAndAccept]: {
      container: {
        backgroundColor: 'red.solid',
        borderColor: 'transparent',
      },
      icon: {
        color: 'red.contrast',
      },
    },
    [IncomingCallButtonVariants.HoldAndAccept]: {
      container: {
        backgroundColor: 'bg.muted',
        borderColor: 'border.muted',
      },
      icon: {
        color: 'green.fg',
      },
    },
    [IncomingCallButtonVariants.ParkAndAccept]: {
      container: {
        backgroundColor: 'bg.muted',
        borderColor: 'border.muted',
      },
      icon: {
        color: 'green.fg',
      },
    },
  },
})

export const useCallIconStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(CallIconStyle, props) as MultiStyleType<
    typeof callIconParts
  >
}
